// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as PorterStoreProductApiModel from "../api-model/PorterStoreProductApiModel.bs.js";

function decodeProduct(data) {
  return {
          code: data.code,
          name: data.name,
          description: data.description,
          list_amount_minor: data.list_amount_minor,
          sale_amount_minor: data.sale_amount_minor,
          currency_code: data.currency_code,
          is_active: data.is_active,
          created_at: data.created_at,
          updated_at: data.updated_at
        };
}

function execute(json) {
  return Belt_Array.map(DeccoUtils$Catalyst.resolveResult(PorterStoreProductApiModel.products_decode(json), "PorterStoreProductEntityMapper.res"), decodeProduct);
}

export {
  decodeProduct ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
